import { useContext } from 'react'
import { RefreshContext } from '../context/RefreshContext'

const useRefresh = () => {
  const { fastest, fast, slow, medium } = useContext(RefreshContext)
  return { fastestRefresh: fastest, fastRefresh: fast, mediumRefresh: medium, slowRefresh: slow }
}

export default useRefresh
